import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { isMobileMode } from "@/lib/environment";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.props.onError?.(error, info);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const release = window.__HIVEFLOW_RELEASE__?.releaseId || "onbekend";
    return (
      <main
        className={`min-h-screen bg-zinc-100 px-4 pb-12 ${isMobileMode() ? "mobile-overlay-safe-top" : "pt-12"}`}
        role="alert"
        data-testid="app-error-boundary"
      >
        <section className="mx-auto max-w-lg rounded-xl border border-red-200 bg-white p-5 shadow-sm">
          <AlertTriangle className="h-6 w-6 text-red-600" aria-hidden="true" />
          <h1 className="mt-3 font-display text-xl font-bold text-zinc-950">Dit scherm kon niet worden geopend</h1>
          <p className="mt-2 text-sm leading-6 text-zinc-600">Je lokale gegevens zijn niet verwijderd. Open het scherm opnieuw; blijft de fout terugkomen, meld dan onderstaande code.</p>
          <code className="mt-3 block break-words rounded-lg bg-zinc-100 p-3 text-xs text-zinc-700">
            {error?.name || "Error"}: {error?.message || "Onbekende fout"} | release {release}
          </code>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-4 inline-flex h-10 items-center gap-2 rounded-lg bg-amber-600 px-4 text-sm font-bold text-white"
          >
            <RefreshCw className="h-4 w-4" aria-hidden="true" />
            Opnieuw openen
          </button>
        </section>
      </main>
    );
  }
}
